<template>
  <v-card min-height="600">
    <v-card-text>
      <v-tabs v-model="tab" grow>
        <v-tab value="bill"><h3>{{ $t('bill.bill_list') }}</h3></v-tab>
        <v-tab value="scheduler-task"><h3>{{ $t('bill.auto_bill') }}</h3></v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" class="pt-4">
        <v-tab-item key="bill">
          <div class="flex items-center justify-between">
            <h3 class="text-bold">{{ $t('bill.bill_list') }}</h3>
            <div>
              <v-btn class="me-1" color="info" @click="loadInvoice(contract.objectId)" icon>
                <v-icon>mdi-reload</v-icon>
              </v-btn>
              <v-btn class="ms-1" color="info" elevation="0" @click="isBillingSelect = true" :disabled="!contract.isActive">
                <v-icon left>mdi-credit-card-outline</v-icon>{{ $t('bill.add_new_bill') }}
              </v-btn>
            </div>
          </div>
          <InvoiceContract :isLoading="isLoading" @onLoad="onLoadInvoice()"></InvoiceContract>
        </v-tab-item>
        <v-tab-item key="scheduler-task">
          <div class="flex items-center justify-between">
            <h3 class="text-bold">{{ $t('bill.billing_list') }}</h3>
            <div>
              <v-btn color="info" elevation="0" @click="isSchedulerTaskInvoiceDialog = true" :disabled="!contract.isActive">
                {{ $t('bill.add_bill_setting') }}
              </v-btn>
            </div>
          </div>
          <SchedulerTaskContract :isLoading="isLoading" @onSaveSuccess="loadSchedulerTask()" @onUpdateInvoice="onLoadInvoice()"></SchedulerTaskContract>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <billing-select
      v-model="isBillingSelect" 
      :contract="contract"
      @onSaveSuccess="onLoadInvoice()"
      @onRemoveSuccess="onLoadInvoice()" 
    />
    <SchedulerTaskInvoiceDialog
      v-model="isSchedulerTaskInvoiceDialog"
      :contract="contract"
      :marketId="marketId"
      :projectId="projectId"
      @onSaveSuccess="loadSchedulerTask()"
      @onActiveSchedulerTask="onLoadInvoice()"
    />
  </v-card>
</template>
<script>
import BillingSelect from "./BillingSelect.vue";
import InvoiceContract from "./InvoiceContract.vue";
import SchedulerTaskContract from "./SchedulerTaskContract.vue";
import SchedulerTaskInvoiceDialog from "./SchedulerTaskInvoiceDialog.vue";
export default {
  components: { 
    InvoiceContract,
    BillingSelect,
    SchedulerTaskContract,
    SchedulerTaskInvoiceDialog,
  },
  props: {
    contract: {
      type: Object,
      default: {}
    },
    contractId: {
      type: String,
      default: ""
    },
    isDialog: Boolean
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      isLoading: false,
      isBillingSelect: false,
      isSchedulerTaskInvoiceDialog: false,
      tab: "bill"
    };
  },
  watch: {
    contractId: {
      handler(value) {
        if (value) {
          this.loadInvoice();
          this.loadSchedulerTask();
        }
      },
      deep: true,
      immediate: true
    },
    isDialog(value) {
      if (value) this.tab = "bill";
    }
  },
  methods: {
    async loadInvoice() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("invoice/getInvoicesByContract", {
          contractId: this.contract.objectId,
          marketId: this.marketId,
          projectId: this.projectId
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    async loadSchedulerTask() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("schedulerTask/getSchedulerTasksByContract", {
          contractId: this.contract.objectId,
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    onLoadInvoice() {
      this.loadInvoice();
      this.$emit("reloadContract");
    },
  }
};
</script>